import React, { Component } from 'react'
import { connect } from 'react-redux'
import DefaultPage from '../../../../Container/Layout/DefaultPage'
import AdminGridList from '../View/AdminGridList'
import {connectedEventsListener } from '../adminEventsAPI'
import AdminConnectedEventsDetails from './AdminConnectedEventDetails'
import { fetchUserProfile, fetchUserProfiles } from '../../../../firebase/database/handleUsers';
import { doSetConfirmedEvent } from '../../../../firebase/database/handleEvents'
import Notification from '../../../../Container/PopUps/Notification'
// import { confirmedEventMessage } from '../../../../js/settings/text'
import * as routes from '../../../../constants/routes'
import moment from 'moment'
const arraySort = require('array-sort');

const headline = {
    headlineText: 'Hilfebedarf nicht bestätigt',
    subheadline: 'Daten werden geladen Laden.....'
}
class AdminConnectedEvents extends Component {
    constructor() {
        super()
        this.state = {
            view: 'list',
            openEvent: null,
            popUp: false,
            notificationMessage: null,
        }
    }
  
    componentDidMount () {
        connectedEventsListener('on')

    }

    toggleView = async (view, event) => {
     
        if(view==='details') {
            this.setState({
                view: 'details',
                openEvent: event
        })
        const requesterData = await fetchUserProfile(event.requester.requesterId)
        const canidateData = await fetchUserProfile(event.canidate.id)
        //eslint-disable-next-line
        const onWaitCanidates = await fetchUserProfiles(event.canidatesOnWait)
        this.setState({
            requester: requesterData,
            canidate: canidateData,
        })

        } else {
            this.setState({view: 'list', openEvent: null})
            
        }
    }

    handleConfirmEvent = (eventId, messageId ) => {
        const confirmedBy = {
            id: this.props.currentAdmin.id,
            name: this.props.currentAdmin.name,
            timeStamp: moment().format(),

        }
        doSetConfirmedEvent(eventId, messageId, confirmedBy)
        const notification = {
            headline: 'Vermittlung abgeschlossen',
            content: 'Der Hilfebedarf wurde für den Helfer bestätigt. Der Helfer wird nicht benachrichtigt. Die Vermittlung ist abgeschlossen'
        }

        this.setState({
            view: 'list',
            popUp: true, 
            notificationMessage: notification
        })
        setTimeout(()=>{ this.setState({popUp: false}) }, 6000)

    }

    handleAlternativConfirmEvent = (eventId, messageId, newCanidate) => {
        const confirmedBy = {
            id: this.props.currentAdmin.id,
            name: this.props.currentAdmin.name,
            timeStamp: moment().format(),
        }
        
        doSetConfirmedEvent(eventId, messageId, confirmedBy, newCanidate)
        const notification = {
            headline: 'Vermittlung abgeschlossen',
            content: 'Der Hilfebedarf wurde für den Helfer bestätigt. Der Helfer wird nicht benachrichtigt. Die Vermittlung ist abgeschlossen'
        }

        this.setState({
            view: 'list',
            popUp: true, 
            notificationMessage: notification
        })
        setTimeout(()=>{ this.setState({popUp: false}) }, 6000)
        

    }


    sortedEvents = async () => {
        const { connectedEvents} = this.props
        const sortedEvents = await arraySort(connectedEvents, 'admin.timeStamp')

        return sortedEvents
    }
    //getConnectedEvents()
    handleOnClick = () =>{
        this.setState({view:'list'})
    }
    render () {
        const { connectedEvents } = this.props
        const { view, popUp } = this.state
        const connectedEventsListInAppNav = [{name: 'Admin Home', route: routes.ADMINHOME}]
        const connectedEventsDetailsInAppNav = [{name: 'Admin Home', route: routes.ADMINHOME}, {name: 'Hilfebedarf nicht besätigt', route: routes.ADMIN_CONNECTED_EVENTS}]
        return (
            <DefaultPage
                handleOnClick={this.handleOnClick}
                headline={headline} links={view==='details' ? connectedEventsDetailsInAppNav : connectedEventsListInAppNav}>

            {this.props.connectedEvents===null || view==='details'
                ? null
                : <AdminGridList events={connectedEvents} type='connected' toggleView={this.toggleView}/>
            }
            {view==='details'
                ? <AdminConnectedEventsDetails 
                        event={this.state.openEvent}
                        toggleView={this.toggleView}
                        requester={this.state.requester}
                        canidate={this.state.canidate}
               //         onWaitCanidates={this.state.onWaitCanidates}
                        handleConfirmEvent={this.handleConfirmEvent}
                        handleAlternativConfirmEvent={this.handleAlternativConfirmEvent}
                        />
                : null //'Derzeit keine Hilfegesuche zum bestätigen vorhanden'
            }
            {popUp 
                ? <Notification notification={this.state.notificationMessage} />
                : null 
            }
            </DefaultPage>
        )
    }
}

const mapStateToProps = (state) => ({
    connectedEvents: state.eventState.connectedEvents,
    currentAdmin: state.userState.profile
})




export default connect(mapStateToProps)(AdminConnectedEvents)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminConnectedEvents/AdminConnectedEvents.js